module.exports = __webpack_public_path__ + "img/pooq-tv-logo01.5c8a6157.png";